export const NOTIFICATION_LEVEL = {
  SYSTEM: 'SYSTEM',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const makeNotification = (level, text, icon) => ({
  level,
  text,
  icon,
});
